import { useCallback, useEffect, useRef, useState } from 'react';
import { Toast } from './ui';

export type ToastApi = {
  show: (message: string) => void;
  message: string;
};

/** One transient toast at a time, matching the design's single-slot pattern. */
export function useToast(): ToastApi {
  const [message, setMessage] = useState('');
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const show = useCallback((next: string) => {
    setMessage(next);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setMessage(''), 3200);
  }, []);

  useEffect(
    () => () => {
      if (timer.current) clearTimeout(timer.current);
    },
    [],
  );

  return { show, message };
}

export function ToastHost({ toast }: { toast: ToastApi }) {
  if (!toast.message) return null;
  return <Toast message={toast.message} />;
}
